import Swiper from 'swiper/bundle';

// swiper
var swiper_team;

$(document).ready(function () {
    if ($(".featureSwiper").length > 0) {

        swiper_team = new Swiper(".featureSwiper", {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                // when window width is >= 841px
                841: {
                    slidesPerView: 3,
                    spaceBetween: 0
                }
            }
        });
        SwiperUpdate_feature();
    }

    $('.clear-btn').on('click', function () {
        $('#news_filter_year').val('all').trigger('change');
        $('#news_filter_region').val('all').trigger('change');
        $('#news_filter_language').val('all').trigger('change');
    });

    //select2
    $('.js-example-basic-single').select2({
        minimumResultsForSearch: Infinity,
    });
    
    $(document).on('mouseenter', '.select2-container', function (e) {
        $(this).prev("select").select2("open");
    });

    $(document).on('mouseleave', '.select2-container .select2-dropdown', function (e) {
        $(".select2-hidden-accessible").select2("close");
    });


    $('form[name=news-filter-form] select').change(function () {
        const select_id = $(this).attr('id');
        const select_value = $(this).val();
        const filter_order_type = $('#news_filter_orderType').val();

        if (select_id == 'news_filter_language') {
            if (filter_order_type == 'letters' && (select_value == 'tc' || select_value == 'sc')) {
                $('#news_filter_orderType').val('publish_date');
                $('#news_filter_order').val('desc');
            }
        }
        $('form[name=news-filter-form]').submit();
    });

    $('#news-dropdown-order .dropdown-item').click(function () {
        const dropdown_type = $(this).data('ordertype');
        const dropdown_value = $(this).data('order');
        $('form[name=news-filter-form] #news_filter_orderType').val(dropdown_type);
        $('form[name=news-filter-form] #news_filter_order').val(dropdown_value);
        $('form[name=news-filter-form]').submit();
    });
});

$(window).resize(function () {
    if ($(".featureSwiper").length > 0) {
        SwiperUpdate_feature();
    }
});

function SwiperUpdate_feature() {
    // const swiper =$('.swiper-m').swiper;
    var ww = $(window).width();
    if (ww <= 841) {

        swiper_team.enabled = true;
        $(swiper_team).each(function (index) {
            this.update()
            this.enabled = true;
        });
        $('.swiper-pagination').removeClass("swiper-pagination-lock");

    } else {
        swiper_team.slideTo(0)
        swiper_team.enabled = false;
        $('.swiper-pagination').addClass("swiper-pagination-lock");
    }
}